import React, { useEffect, useMemo, useState } from 'react';
import { Chart } from 'react-google-charts';
import { barChartOptions } from './BarChartOptions';

export default function BarChart(props: {
    data: any[];
    toUserChart: Function;
    hTitle: string;
    chartColors: string[];
    selectedChart: string;
    isDrillDownAllowed: boolean;
}) {
    const [chartKey, setChartKey] = useState(Math.random());
    const { data, toUserChart, hTitle, chartColors, selectedChart, isDrillDownAllowed } = props;
    const options = useMemo(
        () => barChartOptions(hTitle, chartColors, selectedChart, data, isDrillDownAllowed),
        [hTitle, chartColors, selectedChart, data, isDrillDownAllowed],
    );

    useEffect(() => setChartKey(Math.random()), [data]);

    const getColumns = () => {
        let result: any = [];
        result = data[0]?.map((columnData: string, index: number) =>
            index === 0 ? { type: 'string', label: columnData } : { type: 'number', label: columnData },
        );
        return result;
    };

    const getRows = () => {
        const result: any = [];
        data.forEach((dataRow: [], dataIndex) => {
            if (dataIndex !== 0) {
                result.push(dataRow.map(value => (value === 0 ? null : value)));
            }
        });
        return result;
    };

    return (
        <Chart
            chartType="ColumnChart"
            height="600px"
            rows={getRows()}
            columns={getColumns()}
            options={options}
            key={chartKey}
            chartEvents={[
                {
                    eventName: 'ready',
                    callback: ({ chartWrapper, google }) => {
                        const chart: any = chartWrapper.getChart();
                        const eventClick: any = 'click';
                        var handler = function (e) {
                            toUserChart(e);
                        };
                        google.visualization.events.addListener(chart, eventClick, handler);
                    },
                },
            ]}
        />
    );
}
